import { ElectricityMeterMeasurementType, WaterMeterMeasurementType } from '@enmon/commons';
import { defineMessages } from 'react-intl';
import { Commodity as CommodityEnum } from '@enmon/commons/lib/shared';
import { OutputTechnology } from '@enmon/commons/lib/tools';

export const MeterDetails = defineMessages({
  mct: {
    id: 'app.common.meterDetails.MCT',
  },
  numberOfPhases: {
    id: 'app.common.meterDetails.numberOfPhases',
  },
  numberOfPhasesTooltip: {
    id: 'app.common.meterDetails.numberOfPhasesTooltip',
  },
  numberOfPhasesPlaceholder: {
    id: 'app.common.meterDetails.numberOfPhasesPlaceholder',
  },
  measurementCategory: {
    id: 'app.common.meterDetails.measurementCategory',
  },
  electricityMeasurementCategoryTooltip: {
    id: 'app.common.meterDetails.electricityMeasurementCategoryTooltip',
  },
  gasMeasurementCategoryTooltip: {
    id: 'app.common.meterDetails.gasMeasurementCategoryTooltip',
  },
  mounting: {
    id: 'app.common.meterDetails.mounting',
  },
  mountingTooltip: {
    id: 'app.common.meterDetails.mountingTooltip',
  },
  measurementType: {
    id: 'app.MeterModelsDetails.measurement_type',
  },
  width: {
    id: 'app.common.meterDetails.width',
  },
  widthTooltip: {
    id: 'app.common.meterDetails.widthTooltip',
  },
  tariffs: {
    id: 'app.common.meterDetails.tariffs',
  },
  tariffsTooltip: {
    id: 'app.common.meterDetails.tariffsTooltip',
  },
  numberOfTariffsPlaceholder: {
    id: 'app.common.meterDetails.numberOfTariffsPlaceholder',
  },
  minimumCurrent: {
    id: 'app.common.meterDetails.minimumCurrent',
  },
  minimumCurrentTooltip: {
    id: 'app.common.meterDetails.minimumCurrentTooltip',
  },
  referenceCurrent: {
    id: 'app.common.meterDetails.referenceCurrent',
  },
  referenceCurrentTooltip: {
    id: 'app.common.meterDetails.referenceCurrentTooltip',
  },
  maximumCurrent: {
    id: 'app.common.meterDetails.maximumCurrent',
  },
  maximumCurrentTooltip: {
    id: 'app.common.meterDetails.maximumCurrentTooltip',
  },
  reservedPower: {
    id: 'app.common.meterDetails.reservedPower',
  },
  reservedPowerTooltip: {
    id: 'app.common.meterDetails.reservedPowerTooltip',
  },
  inputSpecification: {
    id: 'app.common.meterDetails.inputSpecification',
  },
  inputSpecificationTooltip: {
    id: 'app.common.meterDetails.inputSpecificationTooltip',
  },
  orientation: {
    id: 'app.common.meterDetails.orientation',
  },
  orientationPlaceholder: {
    id: 'app.common.meterDetails.orientationPlaceholder',
  },
  thermalMeasurementType: {
    id: 'app.common.meterDetails.thermalMeasurementType',
  },
  thermalMeasurementTypePlaceholder: {
    id: 'app.common.meterDetails.thermalMeasurementTypePlaceholder',
  },
  gSize: {
    id: 'app.common.meterDetails.gSize',
  },
  gSizeTooltip: {
    id: 'app.common.meterDetails.gSizeTooltip',
  },
  gSizePlaceholder: {
    id: 'app.common.meterDetails.gSizePlaceholder',
  },
  layLength: {
    id: 'app.common.meterDetails.layLength',
  },
  layLengthTooltip: {
    id: 'app.common.meterDetails.layLengthTooltip',
  },
  layLengthPlaceholder: {
    id: 'app.common.meterDetails.layLengthPlaceholder',
  },
  flange: {
    id: 'app.common.meterDetails.flange',
  },
  flangeTooltip: {
    id: 'app.common.meterDetails.flangeTooltip',
  },
  diameterDimensionNominal: {
    id: 'app.common.meterDetails.diameterDimensionNominal',
  },
  diameterDimensionNominalTooltip: {
    id: 'app.common.meterDetails.diameterDimensionNominalTooltip',
  },
  diameterDimensionNominalPlaceholder: {
    id: 'app.common.meterDetails.diameterDimensionNominalPlaceholder',
  },
  yes: {
    id: 'app.common.yes',
  },
  no: {
    id: 'app.common.no',
  },
  resistance: {
    id: 'app.common.meterDetails.resistance',
  },
  resistanceTooltip: {
    id: 'app.common.meterDetails.resistanceTooltip',
  },
  resistancePlaceholder: {
    id: 'app.common.meterDetails.resistancePlaceholder',
  },
  installationPosition: {
    id: 'app.common.meterDetails.installationPosition',
  },
  installationPositionTooltip: {
    id: 'app.common.meterDetails.installationPositionTooltip',
  },
  installationPositionPlaceholder: {
    id: 'app.common.meterDetails.installationPositionPlaceholder',
  },
  equipmentCategory: {
    id: 'app.common.meterDetails.equipmentCategory',
  },
  serialNumber2: {
    id: 'app.common.meterDetails.serialNumber2',
  },
  serialNumber2Tooltip: {
    id: 'app.common.meterDetails.serialNumber2Tooltip',
  },
  hotWater: {
    id: 'app.common.meterDetails.hotWater',
  },
  hotWaterTooltip: {
    id: 'app.common.meterDetails.hotWaterTooltip',
  },
  woltman: {
    id: 'app.common.meterDetails.woltman',
  },
  woltmanTooltip: {
    id: 'app.common.meterDetails.woltmanTooltip',
  },
  deviceType: {
    id: 'app.common.meterDetails.deviceType',
  },
  deviceTypePlaceholder: {
    id: 'app.common.meterDetails.deviceTypePlaceholder',
  },
  selectDeviceType: {
    id: 'app.common.meterDetails.selectDeviceType',
  },
  mctTooltip: {
    id: 'app.common.meterDetails.mctTooltip',
  },
  mpcPlaceholder: {
    id: 'app.common.meterDetails.mpcPlaceholder',
  },
  meterTechnology: {
    id: 'app.common.meterDetails.meterTechnology',
  },
  measuringTypeTooltip: {
    id: 'app.common.meterDetails.measuringTypeTooltip',
  },
  connectionType: {
    id: 'app.MeterModelsDetails.connectionType',
  },
  waterMeterMeasurementTypeTooltip: {
    id: 'app.common.meterDetails.waterMeterMeasurementTypeTooltip',
  },
  electricityMeterMeasurementTypeTooltip: {
    id: 'app.common.meterDetails.electricityMeterMeasurementTypeTooltip',
  },
  direct: {
    id: 'app.common.meterDetails.detail.direct',
  },
  indirect: {
    id: 'app.common.meterDetails.detail.indirect',
  },
  isDirectPlaceholder: {
    id: 'app.common.meterDetails.isDirectPlaceholder',
  },
  pMaxTooltip: {
    id: 'app.common.meterDetails.pmaxTooltip',
  },
  pMaxPlaceholder: {
    id: 'app.common.meterDetails.pmaxPlaceholder',
  },
  qMinPlaceholder: {
    id: 'app.common.meterDetails.qMinPlaceholder',
  },
  qMinTooltip: {
    id: 'app.common.meterDetails.qMinTooltip',
  },
  qMaxPlaceholder: {
    id: 'app.common.meterDetails.qMaxPlaceholder',
  },
  flowRate: {
    id: 'app.common.meterDetails.flowRate',
  },
  flowRateTooltip: {
    id: 'app.common.meterDetails.flowRateTooltip',
  },
  flowRatePlaceholder: {
    id: 'app.common.meterDetails.flowRatePlaceholder',
  },
  tubeMaterial: {
    id: 'app.common.meterDetails.tubeMaterial',
  },
  tubeMaterialPlaceholder: {
    id: 'app.common.meterDetails.tubeMaterialPlaceholder',
  },
});

export const GasDeviceCategory = defineMessages({
  rotary: {
    id: 'app.common.gasDeviceCategory.rotary',
  },
  membrane: {
    id: 'app.common.gasDeviceCategory.membrane',
  },
  turbine: {
    id: 'app.common.gasDeviceCategory.turbine',
  },
  quantometer: {
    id: 'app.common.gasDeviceCategory.quantometer',
  },
});

export const ElectricityDeviceCategory = defineMessages({
  basic: {
    id: 'app.common.electricityDeviceCategory.basic',
  },
  fourQuadrants: {
    id: 'app.common.electricityDeviceCategory.fourQuadrants',
  },
  multimeter: {
    id: 'app.common.electricityDeviceCategory.multimeter',
  },
  smartCircuitBreaker: {
    id: 'app.common.electricityDeviceCategory.smartCircuitBreaker',
  },
});

export const ElectricityMeasurementType = defineMessages<ElectricityMeterMeasurementType>({
  [ElectricityMeterMeasurementType.Inductive]: {
    id: 'app.common.measurementType.electricity.inductive',
  },
  [ElectricityMeterMeasurementType.Static]: {
    id: 'app.common.measurementType.electricity.static',
  },
});

export const WaterMeasurementType = defineMessages<WaterMeterMeasurementType>({
  [WaterMeterMeasurementType.Mechanical]: {
    id: 'app.common.measurementType.water.mechanical',
  },
  [WaterMeterMeasurementType.Static]: {
    id: 'app.common.measurementType.water.static',
  },
});

export const OtherDeviceCategory = defineMessages({
  gateway: {
    id: 'app.common.otherDeviceCategory.gateway',
  },
  loRaGateway: {
    id: 'app.common.otherDeviceCategory.loRaGateway',
  },
  loRaGatewayPowerSupply: {
    id: 'app.common.otherDeviceCategory.loRaGatewayPowerSupply',
  },
  thermometer: {
    id: 'app.common.otherDeviceCategory.thermometer',
  },
});

export const Mounting = defineMessages({
  din: {
    id: 'app.common.mounting.din',
  },
  cross: {
    id: 'app.common.mounting.cross',
  },
  panel: {
    id: 'app.common.mounting.panel',
  },
});

export const InstallationPosition = defineMessages({
  forward: {
    id: 'app.common.installationPosition.forward',
  },
  return: {
    id: 'app.common.installationPosition.return',
  },
});

export const MeterAccessibility = defineMessages({
  good: {
    id: 'app.common.meterAccessibility.good',
  },
  tenant: {
    id: 'app.common.meterAccessibility.tenant',
  },
  basement: {
    id: 'app.common.meterAccessibility.basement',
  },
  ceiling: {
    id: 'app.common.meterAccessibility.ceiling',
  },
  shaft: {
    id: 'app.common.meterAccessibility.shaft',
  },
  floodedShaft: {
    id: 'app.common.meterAccessibility.floodedShaft',
  },
  high: {
    id: 'app.common.meterAccessibility.high',
  },
  fairlyHigh: {
    id: 'app.common.meterAccessibility.fairlyHigh',
  },
  veryHigh: {
    id: 'app.common.meterAccessibility.veryHigh',
  },
  bad: {
    id: 'app.common.meterAccessibility.bad',
  },
});

export const MeterOwnerType = defineMessages({
  client: {
    id: 'app.common.meterOwnerType.client',
  },
  tenant: {
    id: 'app.common.meterOwnerType.tenant',
  },
  utilityCompany: {
    id: 'app.common.meterOwnerType.utilityCompany',
  },
  lessor: {
    id: 'app.common.meterOwnerType.lessor',
  },
});

export const TubeMaterial = defineMessages({
  copper: {
    id: 'app.common.tubeMaterial.copper',
  },
  plastic: {
    id: 'app.common.tubeMaterial.plastic',
  },
  steel: {
    id: 'app.common.tubeMaterial.steel',
  },
});

export const InventoryMeterMountType = defineMessages({
  free: {
    id: 'app.common.inventoryMeterMountType.free',
  },
  mountedFree: {
    id: 'app.common.inventoryMeterMountType.mountedFree',
  },
  mountedOccupied: {
    id: 'app.common.inventoryMeterMountType.mountedOccupied',
  },
});

export const outputTechnologyTranslated = defineMessages<OutputTechnology>({
  [OutputTechnology.Impulse]: {
    id: 'app.common.outputTechnology.impulse',
  },
  [OutputTechnology.MBus]: {
    id: 'app.common.outputTechnology.mbus',
  },
  [OutputTechnology.WirelessMBus]: {
    id: 'app.common.outputTechnology.wirelessMbus',
  },
  [OutputTechnology['Modbus-RS485']]: {
    id: 'app.common.outputTechnology.modbusModuleRS485',
  },
  [OutputTechnology['Modbus-RS232']]: {
    id: 'app.common.outputTechnology.modbusModuleRS232',
  },
  [OutputTechnology['IEC62056-RS485']]: {
    id: 'app.common.outputTechnology.iec62056-RS485',
  },
  [OutputTechnology['IEC62056-Optical']]: {
    id: 'app.common.outputTechnology.iec62056-Optical',
  },
  [OutputTechnology.Led]: {
    id: 'app.common.outputTechnology.led',
  },
});

export const Commodity = defineMessages<CommodityEnum>({
  [CommodityEnum.Electricity]: {
    id: 'app.common.commodity.electricity',
  },
  [CommodityEnum.Water]: {
    id: 'app.common.commodity.water',
  },
  [CommodityEnum.NaturalGas]: {
    id: 'app.common.commodity.naturalGas',
  },
  [CommodityEnum.Thermal]: {
    id: 'app.common.commodity.thermal',
  },
  [CommodityEnum.Other]: {
    id: 'app.common.commodity.other',
  },
});

export const Orientation = defineMessages({
  horizontal: {
    id: 'app.common.orientation.horizontal',
  },
  verticalFlowUp: {
    id: 'app.common.orientation.verticalFlowUp',
  },
  verticalFlowDown: {
    id: 'app.common.orientation.verticalFlowDown',
  },
});

export const ThermalMeasurementType = defineMessages({
  heat: {
    id: 'app.common.thermalMeasurementType.heat',
  },
  cold: {
    id: 'app.common.thermalMeasurementType.cold',
  },
  both: {
    id: 'app.common.thermalMeasurementType.both',
  },
});
